import { cloneDeep } from 'lodash-es';

export function deepCloneWithPrototype<T>(item: any, prototype: new () => T): T {
    const cloned = cloneDeep(item);
    Object.setPrototypeOf(cloned, prototype.prototype);
    return cloned;
}

export function deepCloneListWithPrototype<T>(items: any[], prototype: new () => T): T[] {
    return items.map(item => {
        return deepCloneWithPrototype(item, prototype);
    });
}

export function deepCloneList<T>(items: T[]): T[] {
    return items.map(item => {
        return cloneDeep(item);
    });
}
